import errorHasStatusCode from './errorHasStatusCode';

export default errorHasStatusCode;
